import { Component, input } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { CmsTeaser } from '@fcom/core-api';

@Component({
  selector: 'cms-back-link',
  templateUrl: './cms-back-link.component.html',
  styleUrls: ['./cms-back-link.component.scss'],
  standalone: false,
})
export class CmsBackLinkComponent {
  readonly SvgLibraryIcon = SvgLibraryIcon;

  content = input.required<CmsTeaser>();
}
